// ### Core Application Configuration
export const SERVER_URL: string | undefined = import.meta.env.VITE_APP_SERVER_URL;
// see https://vuetifyjs.com/en/features/breakpoints/ and vuetify.ts
export const DISPLAY_BREAKPOINT_XS: number | undefined = import.meta.env.VITE_APP_DISPLAY_BREAKPOINT_XS
  ? parseInt(import.meta.env.VITE_APP_DISPLAY_BREAKPOINT_XS, 10)
  : 1200;
export const HAULIER_NAME = import.meta.env.VITE_APP_HAULIER_NAME || 'dpmp';
export const HIDDEN_MODULES = import.meta.env.VITE_APP_HIDDEN_MODULES
  ? import.meta.env.VITE_APP_HIDDEN_MODULES.split(',')
  : [];
export const MIN_CUSTOMER_AGE = import.meta.env.VITE_APP_MIN_CUSTOMER_AGE
  ? parseInt(import.meta.env.VITE_APP_MIN_CUSTOMER_AGE, 10)
  : 15;
export const CUSTOMER_AGE_FOR_CUSTODIAN_REQUIRED = import.meta.env.VITE_APP_CUSTOMER_AGE_FOR_CUSTODIAN_REQUIRED
  ? parseInt(import.meta.env.VITE_APP_CUSTOMER_AGE_FOR_CUSTODIAN_REQUIRED, 10)
  : 15;
export const MIN_CHILD_CUSTOMER_AGE = import.meta.env.VITE_APP_MIN_CHILD_CUSTOMER_AGE
  ? parseInt(import.meta.env.VITE_APP_MIN_CHILD_CUSTOMER_AGE, 10)
  : 10;
export const SENTRY_URL: string | undefined = import.meta.env.VITE_APP_SENTRY_URL;
export const SENTRY_ENV: string | undefined = import.meta.env.VITE_APP_SENTRY_ENV;

// ### Internationalization
export const DEFAULT_LOCALE = import.meta.env.VITE_APP_I18N_LOCALE || 'cs';
export const FALLBACK_LOCALE = import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || 'cs';

// ### Card Management
export const CARD_NUMBER_MASK = import.meta.env.VITE_APP_CARD_NUMBER_MASK;
export const PAK_ALLOWED: boolean = import.meta.env.VITE_APP_PAK_ALLOWED
  ? JSON.parse(import.meta.env.VITE_APP_PAK_ALLOWED)
  : false;

// ### Legal Documents & Terms
export const TERMS_AND_CONDITIONS_URL = {
  REGISTER: import.meta.env.VITE_APP_REGISTER_TERMS_AND_CONDITIONS || 'about:blank',
  CARD_APPLICATION: import.meta.env.VITE_APP_CARD_APPLICATION_TERMS_AND_CONDITIONS || 'about:blank',
};
export const DECLARATION_OF_ACCESSIBILITY: string | undefined = import.meta.env.VITE_APP_DECLARATION_OF_ACCESSIBILITY;
export const CONTACTS_URL: string | undefined = import.meta.env.VITE_APP_CONTACTS;
export const GDPR_URL = {
  REGISTER: import.meta.env.VITE_APP_REGISTER_GDPR || 'about:blank',
  CARD_APPLICATION: import.meta.env.VITE_APP_CARD_APPLICATION_GDPR || 'about:blank',
};
export const FAQ_URL: string | undefined = import.meta.env.VITE_APP_FAQ;

// ### Authentication & Social Integration
export const GOOGLE_CLIENT_ID: string = import.meta.env.VITE_APP_GOOGLE_CLIENT_ID;
export const FACEBOOK_APP_ID: string = import.meta.env.VITE_APP_FACEBOOK_APP_ID;

// ### Payment & Ticketing
export const PAYMENT_CSOB_GATEWAY_BASE_URL: string | undefined = import.meta.env.VITE_APP_PAYMENT_CSOB_GATEWAY_BASE_URL;
export const PAYMENT_GP_GATEWAY_BASE_URL: string = import.meta.env.VITE_APP_PAYMENT_GP_GATEWAY_BASE_URL;
export const TICKET_FARE_MIN_VALID_FROM = import.meta.env.VITE_APP_TICKET_FARE_MIN_VALID_FROM;
